module.exports = __webpack_public_path__ + "img/plan12.665d04fa.svg";